export function createCallbackAppElement(merken, matnr) {
    const callbackElement = document.createElement("callback-app");
    const paramElement = document.createElement("callback-param");
    callbackElement.appendChild(paramElement);

    callbackElement.setAttribute("callback", merken ? "addToWishList" : "removeFromWishList");
    paramElement.setAttribute("key", "matnr");
    paramElement.setAttribute("value", matnr);

    return callbackElement;
}
